<script>
import appConfig from "@/app.config";
import api from "../../../services/api";

import PageList from "../../layouts/page-list";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Users',
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    PageList
  },
  data() {
    return {
      listFields: [
        {key: "id", label: '#', sortable: true, tdAttr: {valign: "middle"}},
        {key: "name", sortable: true, tdAttr: {valign: "middle"}},
        {key: "login", sortable: true, tdAttr: {valign: "middle"}},
        {key: "address", sortable: true, tdAttr: {valign: "middle"}},
        {key: "enable", sortable: true, tdAttr: {valign: "middle"}},
        {key: "roles", sortable: true, tdAttr: {valign: "middle"}},
        {key: "actions", sortable: false, class: 'text-right', label: " ", tdAttr: {valign: "middle"}},
      ],
      listProviderFields: {
        with: 'roles'
      },
      updateListe: false
    }
  },
  methods: {
    displayAddress(item) {
      return (item.address ? item.address : '') + (item.zip_code ? `, ${item.zip_code}` : '') + (item.city ? ` ${item.city}` : '');
    },
    enableDisable(user) {
      api.patch('users', {id: user.id}, user.enable ? 'disable' : 'enable').then(() => {
        this.updateListe = true;
      });
    },
  }
};
</script>

<template>
  <page-list
      resource-name="user"
      :list-fields="listFields"
      :list-provider-fields="listProviderFields"
      :update-liste="updateListe"
      @updated="updateListe = false"
  >
    <template #cell(name)="data">
      <b-row align-v="stretch">
        <b-col md="2">
          <div v-if="!data.item.picture_id" class="avatar-xs">
              <span class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-14">
                {{ data.item.first_name.charAt(0) + (data.item.last_name ? data.item.last_name.charAt(0) : '') }}
              </span>
          </div>
          <div v-else>
            <img :src="`/api/users/${data.item.id}/picture`" :alt="data.item.first_name + ' ' + data.item.last_name"
                 class="rounded-circle img-thumbnail" style="max-height: 50px; max-width: 190px;"/>
          </div>
        </b-col>
        <b-col>
          {{ data.item.first_name }} <b>{{ data.item.last_name }}</b><br>
          <small><a :href="`mailto:${data.item.email}`">{{ data.item.email }}</a></small>
        </b-col>
      </b-row>
    </template>

    <template #cell(enable)="data">
      <b-button :title="$t(data.item.enable ? 'general.disable' : 'general.enable')" size="sm"
                :variant="data.item.enable ? 'success' : 'danger'"
                @click="enableDisable(data.item)">{{ $t(data.item.enable ? 'general.enabled' : 'general.disabled') }}
      </b-button>
    </template>

    <template #cell(address)="data">
      {{ displayAddress(data.item) }}
    </template>

    <template #cell(roles)="data">
      <div v-if="data.item.roles">
                    <span v-for="role in data.item.roles" :key="role.id"
                          class="badge me-2 badge-soft-primary">
                      {{ role.name }}
                    </span>
      </div>
    </template>
  </page-list>
</template>